import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Notice the abandonment",
    opening: localizedGenderNode(
      [
      "Today I don't try to understand everything.",
      "I just notice the feeling of abandonment.",
      "That is enough for now."
    ],
      [
      "Today I don't try to understand everything.",
      "I just notice the feeling of abandonment.",
      "That is enough for now."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "When is the abandonment feeling most felt?",
      "What is happening around me then?",
      "How does it feel in my body?"
    ],
      [
      "When is the abandonment feeling most felt?",
      "What is happening around me then?",
      "How does it feel in my body?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Noticing is already the beginning of connection."
    ],
      [
      "Noticing is already the beginning of connection."
    ]
    ),
    action: localizedGenderNode(
      "one breath with the words \"I am here\".",
      "one breath with the words \"I am here\"."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "What I am missing",
    opening: localizedGenderNode(
      [
      "Today I notice what was missing then.",
      "Without blame.",
      "Just to see."
    ],
      [
      "Today I notice what was missing then.",
      "Without blame.",
      "Just to see."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe slowly.",
      "I feel my chest."
    ],
      [
      "I breathe slowly.",
      "I feel my chest."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What did I need and not receive?",
      "What do I still ask for today?",
      "What is hard for me to ask from others?"
    ],
      [
      "What did I need and not receive?",
      "What do I still ask for today?",
      "What is hard for me to ask from others?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A small lack explains a lot."
    ],
      [
      "A small lack explains a lot."
    ]
    ),
    action: localizedGenderNode(
      "write one word about what is missing.",
      "write one word about what is missing."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "How it stayed in me",
    opening: localizedGenderNode(
      [
      "Today I notice what stayed in me since then.",
      "Without judgment.",
      "Just truth."
    ],
      [
      "Today I notice what stayed in me since then.",
      "Without judgment.",
      "Just truth."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause for a moment.",
      "One breath."
    ],
      [
      "I pause for a moment.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "How does it affect me today?",
      "Where do I feel it in relationships?",
      "What am I trying to protect?"
    ],
      [
      "How does it affect me today?",
      "Where do I feel it in relationships?",
      "What am I trying to protect?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "What stayed in me asks for gentleness."
    ],
      [
      "What stayed in me asks for gentleness."
    ]
    ),
    action: localizedGenderNode(
      "tell myself \"I see you\".",
      "tell myself \"I see you\"."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "The part that feels alone",
    opening: localizedGenderNode(
      [
      "Today I notice the part in me that feels alone.",
      "Not to fix.",
      "Just to be with it."
    ],
      [
      "Today I notice the part in me that feels alone.",
      "Not to fix.",
      "Just to be with it."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe slowly.",
      "I feel my heart."
    ],
      [
      "I breathe slowly.",
      "I feel my heart."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Where does it sit in me?",
      "What does it need from me now?",
      "How does it feel to be with it for a moment?"
    ],
      [
      "Where does it sit in me?",
      "What does it need from me now?",
      "How does it feel to be with it for a moment?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Being with it for a moment is already a small change."
    ],
      [
      "Being with it for a moment is already a small change."
    ]
    ),
    action: localizedGenderNode(
      "place a hand on my heart and breathe.",
      "place a hand on my heart and breathe."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "The fear of leaning",
    opening: localizedGenderNode(
      [
      "Today I check the fear of leaning.",
      "Not to fight.",
      "Just to acknowledge."
    ],
      [
      "Today I check the fear of leaning.",
      "Not to fight.",
      "Just to acknowledge."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause for a moment.",
      "One breath."
    ],
      [
      "I pause for a moment.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What am I afraid of when I lean?",
      "What do I think will happen?",
      "How does this fear protect me?"
    ],
      [
      "What am I afraid of when I lean?",
      "What do I think will happen?",
      "How does this fear protect me?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "The fear of leaning is an attempt to protect."
    ],
      [
      "The fear of leaning is an attempt to protect."
    ]
    ),
    action: localizedGenderNode(
      "tell myself \"I see you\".",
      "tell myself \"I see you\"."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "A small request for safety",
    opening: localizedGenderNode(
      [
      "Today I form a small request for safety.",
      "Not big.",
      "Small."
    ],
      [
      "Today I form a small request for safety.",
      "Not big.",
      "Small."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe.",
      "I am here."
    ],
      [
      "I breathe.",
      "I am here."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What gives me a small sense of safety?",
      "How can I ask for it gently?",
      "What is a small step toward it?"
    ],
      [
      "What gives me a small sense of safety?",
      "How can I ask for it gently?",
      "What is a small step toward it?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "One request can calm the heart."
    ],
      [
      "One request can calm the heart."
    ]
    ),
    action: localizedGenderNode(
      "write the request in one sentence.",
      "write the request in one sentence."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "A small moment of closeness",
    opening: localizedGenderNode(
      [
      "Today I look for a small moment of safe closeness.",
      "Not much.",
      "Just a little."
    ],
      [
      "Today I look for a small moment of safe closeness.",
      "Not much.",
      "Just a little."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause for a moment.",
      "One breath."
    ],
      [
      "I pause for a moment.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "When did I have safe closeness recently?",
      "What allowed it to happen?",
      "What could invite another moment like that?"
    ],
      [
      "When did I have safe closeness recently?",
      "What allowed it to happen?",
      "What could invite another moment like that?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A small moment shifts direction."
    ],
      [
      "A small moment shifts direction."
    ]
    ),
    action: localizedGenderNode(
      "remember one such moment.",
      "remember one such moment."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "A boundary that protects me",
    opening: localizedGenderNode(
      [
      "Today I check a small boundary that protects me.",
      "Not to distance.",
      "Just to protect."
    ],
      [
      "Today I check a small boundary that protects me.",
      "Not to distance.",
      "Just to protect."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe slowly.",
      "I feel my shoulders."
    ],
      [
      "I breathe slowly.",
      "I feel my shoulders."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Where do I give too much?",
      "What small boundary would ease me?",
      "How can I say it to myself?"
    ],
      [
      "Where do I give too much?",
      "What small boundary would ease me?",
      "How can I say it to myself?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A small boundary protects the heart."
    ],
      [
      "A small boundary protects the heart."
    ]
    ),
    action: localizedGenderNode(
      "one boundary sentence to myself.",
      "one boundary sentence to myself."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "Staying with myself",
    opening: localizedGenderNode(
      [
      "Today I practice staying with myself when abandonment rises.",
      "Not running away.",
      "Just being."
    ],
      [
      "Today I practice staying with myself when abandonment rises.",
      "Not running away.",
      "Just being."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause for a moment.",
      "One breath."
    ],
      [
      "I pause for a moment.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What helps me stay with me?",
      "What takes me away from me?",
      "What could help me return?"
    ],
      [
      "What helps me stay with me?",
      "What takes me away from me?",
      "What could help me return?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Staying with me is a small anchor."
    ],
      [
      "Staying with me is a small anchor."
    ]
    ),
    action: localizedGenderNode(
      "one breath each time the feeling rises.",
      "one breath each time the feeling rises."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "One clear request",
    opening: localizedGenderNode(
      [
      "Today I form one clear request for myself.",
      "Not big.",
      "Clear."
    ],
      [
      "Today I form one clear request for myself.",
      "Not big.",
      "Clear."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe.",
      "I am here."
    ],
      [
      "I breathe.",
      "I am here."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What do I need right now to feel safe?",
      "How can I ask for it gently?",
      "What is a small step toward it?"
    ],
      [
      "What do I need right now to feel safe?",
      "How can I ask for it gently?",
      "What is a small step toward it?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "One clear request can calm me."
    ],
      [
      "One clear request can calm me."
    ]
    ),
    action: localizedGenderNode(
      "write the request in one sentence.",
      "write the request in one sentence."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "One value that holds me",
    opening: localizedGenderNode(
      [
      "Today I look for one value that holds me.",
      "Small.",
      "But true."
    ],
      [
      "Today I look for one value that holds me.",
      "Small.",
      "But true."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause for a moment.",
      "One breath."
    ],
      [
      "I pause for a moment.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Which value matters to me inside a bond?",
      "How does that value look on an ordinary day?",
      "What small step could honor it?"
    ],
      [
      "Which value matters to me inside a bond?",
      "How does that value look on an ordinary day?",
      "What small step could honor it?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "One value is a thread of stability."
    ],
      [
      "One value is a thread of stability."
    ]
    ),
    action: localizedGenderNode(
      "one word that expresses the value.",
      "one word that expresses the value."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "Listening to my need",
    opening: localizedGenderNode(
      [
      "Today I listen to my need.",
      "Not to push it away.",
      "Just to hear it."
    ],
      [
      "Today I listen to my need.",
      "Not to push it away.",
      "Just to hear it."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe slowly.",
      "I feel my belly."
    ],
      [
      "I breathe slowly.",
      "I feel my belly."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What is the most alive need in me now?",
      "How does it sound in simple words?",
      "What could give it a small place?"
    ],
      [
      "What is the most alive need in me now?",
      "How does it sound in simple words?",
      "What could give it a small place?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Hearing the need is already a change."
    ],
      [
      "Hearing the need is already a change."
    ]
    ),
    action: localizedGenderNode(
      "write the need in one word.",
      "write the need in one word."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "A small step of safety",
    opening: localizedGenderNode(
      [
      "Today I choose a small step of safety.",
      "No drama.",
      "A small step."
    ],
      [
      "Today I choose a small step of safety.",
      "No drama.",
      "A small step."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause for a moment.",
      "One breath."
    ],
      [
      "I pause for a moment.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What small step am I willing to try?",
      "What will feel safe enough?",
      "How will it protect me?"
    ],
      [
      "What small step am I willing to try?",
      "What will feel safe enough?",
      "How will it protect me?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A small step is enough to get closer."
    ],
      [
      "A small step is enough to get closer."
    ]
    ),
    action: localizedGenderNode(
      "choose one small step and remember it.",
      "choose one small step and remember it."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Return sentence",
    opening: localizedGenderNode(
      [
      "Today I choose a sentence that brings me back to safety.",
      "When I get scared.",
      "A small sentence."
    ],
      [
      "Today I choose a sentence that brings me back to safety.",
      "When I get scared.",
      "A small sentence."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe.",
      "I am here."
    ],
      [
      "I breathe.",
      "I am here."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What did I learn about this abandonment?",
      "What is the first sign it returns?",
      "Which sentence brings me back a moment before?"
    ],
      [
      "What did I learn about this abandonment?",
      "What is the first sign it returns?",
      "Which sentence brings me back a moment before?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "I can feel abandoned and still stay with myself."
    ],
      [
      "I can feel abandoned and still stay with myself."
    ]
    ),
    action: localizedGenderNode(
      "say the new sentence once.",
      "say the new sentence once."
    ),
  },
].map(buildNormalizedDay);

export const feelingOfAbandonmentParentsAreEmotionallyPhysicallyUnavailableBlueprintEn = buildNormalizedPilotBlueprint({
  id: "feeling_of_abandonment_parents_are_emotionally_physically_unavailable_14d",
  version: "tri_locale_emit_en_v1",
  durationDays: 14,
  problemKey: "feeling_of_abandonment_parents_are_emotionally_physically_unavailable",
  category: "childhood_parents_past_wounds",
  journeyName: {
    he: "תחושת נטישה (הורים לא זמינים רגשית / פיזית)",
    en: "Feeling of abandonment (parents emotionally/physically unavailable)",
    es: "Sensación de abandono (padres no disponibles emocional o físicamente)",
  },
  days,
});

export default feelingOfAbandonmentParentsAreEmotionallyPhysicallyUnavailableBlueprintEn;
